
import { isInAppBrower, isInGoArtAppBrower, getHost, getBrowser, getGoArtClientInfo, compareVersion } from '~/utils/common'
export default ({ app, store }, inject) => {
    let hideToastTask = 0;//记录 hideToast setTimeout id
    let browser = {};
    let isInFotorApp = false;
    let isInGoArtApp = false;
    let isInApp = false;
    let isiOS = false;
    let isAndroid = false;
    let appVersion = "1.0.0";

    if (process.client) {
        isInFotorApp = !!isInAppBrower();
        isInGoArtApp = !!isInGoArtAppBrower();
        isInApp = isInGoArtApp || isInFotorApp;
        browser = getBrowser();
        // console.log('=======>browser',browser)
        isiOS = browser.isiOS;
        isAndroid = browser.isAndroid;
        appVersion = getGoArtClientInfo().appVersion || appVersion;

    }

    //app.$t 在这里用不了，临时实现一个，只在本插件内使用
    function getI18n (k) {
        const currentLang = app.$pageLanguage;
        let data = app.i18n.messages[currentLang];
        if (!data[k]) {
            const defaultLang = app.i18n.fallbackLocale;
            data = app.i18n.messages[defaultLang];
            console.warn(`当前语言 ${currentLang} 下的 "${k}" 不存在，切换到默认语言 ${defaultLang} 去读取`)
        }
        return data[k];
    }

    const mobileCommon = {
        isInApp,
        isInFotorApp,
        isInGoArtApp,
        browser,
        /**
         * 【旧版】显示弹窗消息
         * @param {string} msg 内容
         * @param {string} btnText 按钮文本
         */
        showMsgBox (msg, btnText = "") {
            let msgBoxData = {
                content: msg,
                show: true,
            }
            btnText && (msgBoxData.btnText = btnText);
            store.commit("mobile/setMsgBoxData", msgBoxData);
        },

        /**
         * 【新版】显示弹窗消息
         * @param {string} msg 内容
         * @param {string} btnText 按钮文本
         */
        showMsgBox2 (msg, btnText, btnClick) {
            //复用 ConfirmBox 的做为消息弹窗
            this.showConfirm(
                "",
                msg,
                btnClick || (() => {
                    this.hideMsgBox2();
                }),
                "",
                btnText,
                true,
            )
        },
        hideMsgBox2 () {
            this.hideConfirm();
        },


        /**
         * 未登录消息弹窗，点击确认转到登陆页
         * @param {*} msg
         * @param {*} btnOkText
         */
        showNotLoginMsgBox (msg = getI18n('common').msgs['403'], btnOkText = "") {
            // 目前 Android 3.3.0以下 打开 goart://login 时就有一个弹窗提示，所以就不显示网页版弹窗。
            // 目前 iOS 打开 goart://login 时与Android相反，不会有弹窗，所以需要网页版做一个弹窗

            if (isInApp && isAndroid && compareVersion(appVersion, "3.3.0") === -1) {
                this.openGoArtNativeLogin();
            } else {
                // app外、iOS、android 3.3.0及以上，显示网页版弹窗
                this.showConfirm(
                    "",
                    msg,
                    (() => {
                        this.hideConfirm();
                        this.openGoArtNativeLogin();
                    }),
                    "",
                    btnOkText,
                    false,
                )
            }
        },


        /**
         * 显示确认弹窗
         * @param {string} title 标题
         * @param {string} content 内容
         * @param {string} confirmBtnClick 确认按钮点击事件
         * @param {string} cancelBtnText 取消按钮文本
         * @param {string} confirmBtnText 确认按钮文本
         * @param {string} hideCancelBtn 不显示关闭按钮
         */
        showConfirm (
            title,
            content,
            confirmBtnClick,
            cancelBtnText = "",
            confirmBtnText = "",
            hideCancelBtn = false,
            cancelBtnClick,
            btnDirection = ""
        ) {
            let data = {
                title,
                content,
                hideCancelBtn,
                confirmBtnClick,
                show: true,
            }
            data.cancelBtnText = cancelBtnText || getI18n('common').confirmBox.btnCancel;
            data.confirmBtnText = confirmBtnText || getI18n('common').confirmBox.btnOk;
            data.cancelBtnClick = cancelBtnClick || 'default';
            data.btnDirection = btnDirection || "Horizontal";
            store.commit("mobile/setConfirmData", data);
        },

        /**
         * 显示确认弹窗,内容通过 v-html 渲染的
         */
        showConfirmWithHtmlContent (
            title,
            htmlContent,
            confirmBtnClick,
            cancelBtnText = "",
            confirmBtnText = "",
            hideCancelBtn = false,
            cancelBtnClick,
            btnDirection = ""
        ) {
            let data = {
                title,
                htmlContent,
                hideCancelBtn,
                confirmBtnClick,
                show: true,
            }
            data.cancelBtnText = cancelBtnText || getI18n('common').confirmBox.btnCancel;
            data.confirmBtnText = confirmBtnText || getI18n('common').confirmBox.btnOk;
            data.cancelBtnClick = cancelBtnClick || 'default';
            data.btnDirection = btnDirection || "Horizontal";
            store.commit("mobile/setConfirmData", data);
        },

        hideConfirm () {
            store.commit("mobile/setConfirmShow", false);
        },

        /**
         * 显示 toast 提示
         * @param {*} msg 内容
         * @param {*} t 多久后消失,单位毫秒
         */
        showToast (msg, theme = "", t = 2500) {
            store.commit("mobile/setToastData", {
                content: msg,
                theme,
                show: true,
            });
            hideToastTask && clearTimeout(hideToastTask)
            hideToastTask = setTimeout(() => {
                store.commit("mobile/setToastData", {
                    show: false,
                });
            }, t)
        },

        /**
         * 显示或隐藏全屏loading
         * @param {*} show 显示或隐藏 true/false
         * @param {*} text loading 内容文本
         * @param {*} theme 主题颜色 Dark/Light
         */
        fullLoading (show, text, theme = "Light") {
            store.commit("mobile/setMobileState", { key: "fullLoadingData", value: { show, text, theme } });
        },

        /**
         * 显示或隐藏 toast loading
         * @param {*} show 显示或隐藏 true/false
         * @param {*} text loading 内容文本
         * @param {*} theme 主题颜色 Dark/Light
         */
        toastLoading (show, text, theme = "Light") {
            store.commit("mobile/setMobileState", { key: "toastLoadingData", value: { show, text, theme } });
        },

        /**
         * 显示或隐藏 toast loading, 内容通过 v-html 渲染的
         */
        toastLoadingWithHtmlContent (show, htmlContent, theme = "Light") {
            store.commit("mobile/setMobileState", { key: "toastLoadingData", value: { show, htmlContent, theme } });
        },

        setOpenInAppData (schema, show = true) {
            store.commit("mobile/setMobileState", { key: "openInAppData", value: { show, schema } });
        },
        gotoPolygon (address) {
            let href = "https://polygonscan.com";
            if (address) {
                href += '/address/' + address;
            }
            location.href = href;
        },

        //app内使用新webview打开
        /**
         * url: webUrl

         * @param {*} url webUrl
         * @param {*} param1.notShare 是否需要展示导航栏右上角分享按钮（1-不展示 0-展示）
         * @param {*} param1.clearNavigateBar 0/未配置-默认导航栏 1-导航栏透明
         * @param {*} param1.newShareChannel 0/未配置-显示默认分享渠道  1-
         */
        newWebViewOpen (url, { notShare = 0, clearNavigateBar = 0, newShareChannel = 0 } = {}) {
            if (isInApp) {
                if (url[0] === '/') {
                    url = getHost() + url;
                }
                let schema = `goart://webview?url=${encodeURIComponent(url)}&notShare=${notShare}&clearNavigateBar=${clearNavigateBar}&newShareChannel=${newShareChannel}`
                location.href = schema;
            } else {
                console.log('app', app)
                app.router.push(url);
            }
        },

        //gaort：打开原生登陆页
        openGoArtNativeLogin () {
            if (isInApp) {
                let schema = `goart://login`;
                location.href = schema;
            } else {
                console.log('Outside app');
            }
        }
    }
    inject('mobile', mobileCommon)
}